export default __webpack_public_path__ + "static/media/Aakash_Desktop.54d374d0.png";